import { Component, ViewChild, OnDestroy } from '@angular/core';
import { SearchFilter, IFilterResponse } from 'src/app/infrastructure/iFilter-component';
import { PagerControlComponent } from '../../controls/pager/pager-control.component';
import { MatTableDataSource, MatSort, MatDialog } from '@angular/material';
import { SearchFilterComponent } from '../../search-filter/search-filter.component';
import { MenuService } from 'src/app/services/menu.service';
import { MedicalAppointmentWaitSearchItem } from 'src/app/model/medical-appointment/medical-appointment-wait-search-item';
import { ReservationService } from 'src/app/services/reservation.service';
import { Reservation } from 'src/app/model/reservation';
import { ReservationRescheduleWizardService } from 'src/app/services/wizard/reservation/reservation-reschedule.wizard.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { MedicalAppointmentWaitTraceDialogComponent } from '../../dialogs/medical-appointment-wait-trace-dialog/medical-appointment-wait-trace-dialog.component';
import { MedicalAppointmentCancel } from 'src/app/model/medical-appointment-cancel';
import { PatientViewDialogComponent } from '../../dialogs/patient-view/patient-view-dialog.component';
import { MessageServerService } from 'src/app/services/hub-services/message-server/message-server.service';
import { PushNotificationsService } from 'ng-push';

@Component({
  selector: 'app-medical-appointment-wait-search',
  templateUrl: './medical-appointment-wait-search.component.html',
  styleUrls: ['./medical-appointment-wait-search.component.css']
})
export class MedicalAppointmentWaitSearchComponent implements OnDestroy {
  canCancelAdmited: boolean;
  loaded: boolean;
  loadingAction: boolean;
  searchFilters: SearchFilter[];
  widthTableExp: number;
  @ViewChild('pager', {static: true}) pager: PagerControlComponent;
  displayedColumns: string[] = ['date', 'dateContact', 'timeContact', 'patientFullName', 'patientCelPhone', 'stateName',
                                'serviceName', 'star'];

  dataSource = new MatTableDataSource([]);
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  @ViewChild('searchFilter', {static: false}) searchFilter: SearchFilterComponent;

  constructor(public dialog: MatDialog,
    private reservationService: ReservationService,
    private reservationRescheduleWizardService: ReservationRescheduleWizardService,
    private notificationToastService: NotificationToastService,
    private menuService: MenuService) {
    this.menuService.setMenuTitle('Reserva', 'turnos en espera');

  }

  resizeColumn() {
  }

  onStartSearch() {
  }

  ngOnDestroy(): void {

  }

  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = new MatTableDataSource(pagedItems);
    this.loaded = true;
  }

  onEndSearch(response: IFilterResponse<MedicalAppointmentWaitSearchItem>) {
    this.pager.setItems(response.items);
    this.searchFilters = response.searchFilters;
  }

  applyFilter() {
  }

  viewTrace(medicalAppointmentWaitSearchItem: MedicalAppointmentWaitSearchItem) {
    const dialogRef = this.dialog.open(MedicalAppointmentWaitTraceDialogComponent, {
      width: '50%',
      data: medicalAppointmentWaitSearchItem.Id
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result) {
        this.searchFilter.search();
      }
    });
  }

  openPatientViewDialog(medicalAppointmentWaitSearchItem: MedicalAppointmentWaitSearchItem): void {
    const dialogRef = this.dialog.open(PatientViewDialogComponent, {
      width: '70%',
      data: { patientId: medicalAppointmentWaitSearchItem.PatientId }
    });
  }


  async startReservationWizard(medicalAppointmentWaitSearchItem: MedicalAppointmentWaitSearchItem) {
    try {
      medicalAppointmentWaitSearchItem.Loading = true;
      const medicalAppointmentWaitIds: number[] = [];
      medicalAppointmentWaitIds.push(medicalAppointmentWaitSearchItem.Id);
      const reservationInfo = await this.reservationService.getMedicalAppointmentWaitReservation(medicalAppointmentWaitIds);
      this.reservationRescheduleWizardService.setReservationAndStartWizard(
        new Reservation(reservationInfo), 'medical-appointment-wait-search');
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Turno espera');
    } finally {
      medicalAppointmentWaitSearchItem.Loading = false;
    }
  }
}
